import {MapSearchGrid} from "@/features/search";
import {filterValidValuesToObject} from "@/shared/lib";
import {vars} from "@/shared/lib/theme.css";
import {MapSearchType} from "@/shared/model";
import {Column} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_layout/search/map-search")({
	component: MapSearchScreen,
	validateSearch: (search: Partial<MapSearchType>): Partial<MapSearchType> => {
		return filterValidValuesToObject<MapSearchType, MapSearchType>(search);
	}
});

function MapSearchScreen() {
	return (
		<Column fullWidth style={{gap: vars.size[32], alignItems: "flex-start"}}>
			{/* <MapSearchForm /> */}
			<MapSearchGrid />
		</Column>
	);
}
